import React from "react";
import { Select, MenuItem, Typography, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const CustomDropDownColor = ({
  handleSelect,
  selectedValue,
  options,
  name,
  label,
  placeholder,
  addPlusIcon,
  isRequired,
  disabled,
  minWidth,
}) => {
  const menuProps = {
    PaperProps: {
      sx: {
        width: "250px",
        maxHeight: "200px",
      },
    },
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "right",
    },
  };

  const getOptionStyle = (label) => {
    const lower = label.toLowerCase();
    if (lower.includes("problem")) return { backgroundColor: "#d32f2f", textColor: "white" };
    if (lower.includes("follow")) return { backgroundColor: "#fbc02d", textColor: "white" };
    if (lower.includes("ok")) return { backgroundColor: "#388e3c", textColor: "white" };
    return { backgroundColor: "#e0e0e0", textColor: "black" };
  };

  const getOptionHoverColor = (label) => {
    const lower = label.toLowerCase();
    if (lower.includes("problem")) return "#c62828";
    if (lower.includes("follow")) return "#f9a825";
    if (lower.includes("ok")) return "#2e7d32";
    return "#d5d5d5";
  };

  const selectedOption = options?.find((option) => option.id === selectedValue);
  const selectedStyle = selectedOption
    ? getOptionStyle(selectedOption.name)
    : { backgroundColor: "#fff", textColor: "#000" };

  return (
    <Box sx={{ width: "100%" }}>
      <Box mt={2} sx={{ display: "flex", minWidth: minWidth || "20px" }}>
        <Select
          value={selectedValue || ""}
          onChange={(event) => handleSelect(event, name)}
          displayEmpty
          disabled={disabled}
          MenuProps={menuProps}
          sx={{
            flexGrow: 1,
            backgroundColor: selectedStyle.backgroundColor,
            color: selectedStyle.textColor,
            textAlign: "center", 
            "& .MuiSelect-select": {
              padding: "2px ",
              minHeight: "14px",

              color: selectedStyle.textColor,
              backgroundColor: selectedStyle.backgroundColor,
            },
          }}
          renderValue={(value) => {
            const normalizedValue = Array.isArray(value) ? value[0] : value;
            const selected = options?.find((option) => option.id == normalizedValue);            if (!selected) {
              return <span style={{ color: "#888" }}>{placeholder || "Select"}</span>;
            }
            const style = getOptionStyle(selected.name);
            return (
              <span style={{ color: style.textColor, backgroundColor: style.backgroundColor }}>
                {selected.name}
              </span>
            );
          }}
          
        >
          <MenuItem disabled value="">
            {placeholder || "Select"}
          </MenuItem>
          {options?.map((option, index) => {
            const style = getOptionStyle(option.name);
            const isSelected = selectedValue === option.id;
            return (
              <MenuItem
                key={index}
                value={option.id}
                sx={{
                  height: "36px",
                
                  fontWeight: isSelected ? "bold" : "normal",
                  "&.Mui-selected": {
                    
                  },
                  "&.Mui-selected:hover": {
                    backgroundColor: getOptionHoverColor(option.name) + " !important",
                  },
                  "&:hover": {
                    backgroundColor: getOptionHoverColor(option.name),
                  },
                }}
              >
                {option.name}
              </MenuItem>
            );
          })}
        </Select>

        {addPlusIcon && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              paddingLeft: "8px",
              cursor: "pointer",
            }}
            onClick={() => console.log("Add icon clicked")}
          >
            <AddIcon sx={{ color: "#1976d2" }} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default CustomDropDownColor;
